import { jsx as _jsx } from "react/jsx-runtime";
import { useAccess, useAppReadLocalStorage } from '@/warehouse/hooks';
import { appSections } from '@/warehouse/navigation';
import { Navigate } from 'react-router-dom';
const NavigateToMainPage = () => {
    const { userCrossDocks, userStockLocations } = useAccess();
    const crossDockId = useAppReadLocalStorage({ key: 'crossDockId', initialValue: 0 });
    const locationId = useAppReadLocalStorage({ key: 'stockLocationId', initialValue: 0 });
    if (userCrossDocks.length > 0) {
        return _jsx(Navigate, { to: appSections.crossdockingReceipt.getLinkTo(crossDockId || userCrossDocks[0]), replace: true });
    }
    if (userStockLocations.length > 0) {
        return _jsx(Navigate, { to: appSections.stockReceipt.getLinkTo(locationId || userStockLocations[0]), replace: true });
    }
    return _jsx(Navigate, { to: "access", replace: true });
    // return <Navigate to={appSections.settings.linkTo} replace />;
};
export { NavigateToMainPage };
